let base;
let domain = window.location.host;
let hotelType = domain.indexOf('localhost') !== -1
if(hotelType || process.env.NODE_ENV.indexOf('test') != -1){
  console.log(hotelType,'url--------')
   base = 'xinjngtech.com'
}else{
   base = process.env.NODE_SHARE_DOMAIN || 'xinjingtech.net'
}
export default base;


// WEBPACK FOOTER //
// ./src/api/domin.js